import './style.less';
import { INTEGRATION_STATUS } from '../../constants';

class IntegrationController {
  constructor(Authentication, IntegrationService, $state, $location) {
    'ngInject';

    Object.assign(this, { Authentication, IntegrationService, $state, $location });
  }

  async $onInit() {
    const { platform } = this.$state.params;
    const goToIntegrations = (type = null) =>
      this.$state.go('settings', { tab: 'integrations', type });
    const integration = await this.IntegrationService.getIntegrationByPlatform(platform);

    if (!integration) {
      return goToIntegrations();
    }

    if (integration.status === INTEGRATION_STATUS.ENABLED) {
      return goToIntegrations();
    }

    if (integration.parameters) {
      try {
        const payload = this.IntegrationService.parseParameters(
          integration,
          this.$location.search()
        );
        await this.IntegrationService.setParameters(integration, payload);
      } catch (e) {
        return goToIntegrations(platform);
      }
    }

    this.IntegrationService.connect(integration);
  }
}

export default {
  template: `
    <div class="integration__container">
      <sling-loader></sling-loader>
    </div>
  `,
  controller: IntegrationController,
};
